<template>
  <div v-if="data" class="my-purchase-cell">
    <div class="my-purchase-top" :class="periodExpiration(data.enddatetime, 'period-expiration-style')">
      <div class="con-img thumb-image">
        <div class="img-wrap">
          <a @click.prevent="movePlay(data)" href="#">
            <img class="thumb-img" v-lazy="getLazyLoadObj(data)" :alt="data.title"/>
            <age-limits :targetAge="+data.targetage" :contentType="data.contenttype"/>
            <div :class="adultDimClass"></div>
          </a>
        </div>
      </div>
      <div class="my-purchase-check check-style" v-if="editorMode">
        <input type="checkbox" name="chkSeq" :value="data.paymentid" v-model="checked" @click="checkedPurchase(data.paymentid)"
               :id="'ch-'+data.paymentid" class="check-blue-dark"><label :for="'ch-'+data.paymentid"><span>선택</span></label>
      </div>
      <div class="con-text-wrap">
        <div class="my-purchase-tag">
          <i :class="data.contenttype === 'movie' ? 'tag-movie' :'tag-vod'">{{data.contenttype === 'movie' ? '영화' :
            'VOD'}}</i>
          <i v-if="data.own === 'y'" class="tag-permanent">영구소장</i>
          <i v-else-if="periodExpiration(data.enddatetime)" class="tag-expire">기한만료</i>
          <i v-else class="tag-rental">대여상품</i>
        </div>
        <p class="con-tit">{{ data.title }}</p>
        <p class="con-text01">
          <span>구매일</span>
          <span class="title-dot"></span>
          <span>{{ data.startdatetime }}</span>
        </p>
        <p class="con-text01">
          <span>구매금액</span>
          <span class="title-dot"></span>
          <span>{{ data.price.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,') }}원</span>
        </p>
        <p v-if="data.own === 'y'" class="con-text01">
          <span>만료일</span>
          <span class="title-dot"></span>
          <span>영구소장</span>
        </p>
        <p v-else class="con-text01">
          <span>만료일</span>
          <span class="title-dot"></span>
          <span>{{ data.enddatetime }}</span>
        </p>
        <p class="con-text01">
          <span>결제방법</span>
          <span class="title-dot"></span>
          <span>{{ data.paidtypetext }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AgeLimits from '@/components/model/AgeLimits'
import { addPostfixAndUrl } from '@/common/utils/common'
import breakDown from '@/mixins/breakdown.mixin'
import { resizeThumbnail } from '@/common/utils/image'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'
import { PATH_NAME_PLAYER_MOVIE, PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'
export default {
  name: 'BreakListSinglePurchase.vue',
  filters: {
    addPostfixAndUrl
  },
  mixins: [
    breakDown
  ],
  components: {
    AgeLimits
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    editorMode: {
      type: Boolean
    },
    viewMode: {
      type: String
    },
    setCheckFn: {
      type: Function
    },
    checkedData: {
      type: Boolean
    }
  },
  data () {
    return {
      checked: false,
      placeholderImage: require('../../../assets/images/common/img_default_thum_1.png')
    }
  },
  computed: {
    adultDimClass () {
      if (cookie.isNotVerifiedAdultUser() && _.get(this.data, 'targetage', 0) >= 21) {
        return _.get(this.data, 'contenttype', '') === 'movie' ? 'movie-lock-21' : 'vod-lock-21'
      }
      return ''
    }
  },
  methods: {
    periodExpiration (endTime, data) {
      if (new Date(endTime.replace(/-/g, '/')) > new Date()) return false
      if (data) return data
      return true
    },
    movePlay (data) {
      if (this.editorMode) return
      if (data.contenttype === 'vod') {
        this.$router.push({
          name: PATH_NAME_PLAYER_VOD,
          query: {
            contentid: data.contentid
          }
        })
      } else if (data.contenttype === 'movie') {
        this.$router.push({
          name: PATH_NAME_PLAYER_MOVIE,
          query: {
            movieid: data.contentid
          }
        })
      }
    },
    imageFileName (contentType) {
      var filename = ''
      var imagePath = require.context('../../../assets/images/mypooq/', false, /\.png$/)

      if (contentType === 'vod') {
        filename = 'tag-vod'
      } else if (contentType === 'movie') {
        filename = 'tag-movie'
      }
      return imagePath('./' + filename + '.png')
    },
    checkedPurchase (paymentid) {
      this.setCheckFn(paymentid)
    },
    getLazyLoadObj (movieItem) {
      return {
        src: resizeThumbnail(movieItem.image, { width: 210, height: 300, isSquare: false }),
        error: this.placeholderImage,
        loading: this.placeholderImage
      }
    }
  },
  created () {
    this.$events.$on('reset', () => {
      this.checked = false
    })
  },
  beforeDestroy () {
    this.$events.$off('reset')
  }
}
</script>

<style scoped>
  .period-expiration-style{opacity: 0.6;}
  /*.period-expiration-style .con-img .img-wrap:before {content:""; display:block; clear:both; position:absolute; top:0; left:0; right:0; bottom:0; z-index:810; width:100%; height:100%; background-color:#fff; opacity:0.6;}*/
  /*.period-expiration-style .con-text-wrap .con-tit,*/
  /*.period-expiration-style .con-text-wrap .con-text01 {color:#ccc;}*/
  /*.period-expiration-style .con-text-wrap .title-dot {border:1px solid #ccc;}*/
</style>
